import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { BaseApi } from '@/api/base-api';

export interface ProvidersDistItemResponse {
  id: string;
  slug: string;
  title: string;
}

export class PresetsApi extends BaseApi {
  private controller = '/common/catalog';

  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  public async dist(): Promise<ProvidersDistItemResponse[]> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/dict/presets`,
      {},
    );
  }
}
